import axios from "axios";
import { REACT_APP_API_URL } from "../api/global";

export const fetchProfessionalTournaments =
  (token, page) => async (dispatch) => {
    dispatch({ type: "FETCH_PROFESSIONAL_TOURNAMENT_REQUEST" });

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/getAllProfessionalTournaments?page=${page}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      dispatch({
        type: "FETCH_PROFESSIONAL_TOURNAMENT_SUCCESS",
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: "FETCH_PROFESSIONAL_TOURNAMENT_FAILURE",
        payload: error.message,
      });
    }
  };
